<template>
  <v-layout class="product">
    <v-flex xs3 sm2 class="product-img">
      <v-img
        :src="product.photourl.split(';;')[0]"
        alt="product.name"
        class="img-responsive"
        lazy
        aspect-ratio="1"
        v-if="product.photourl.split(';;').length > 0"
      />
    </v-flex>
    <v-flex xs9 sm10 class="detail pl-2 pr-2">
      <div class="name small">
        {{ product.name }}
        <template v-if="product.option"
          >({{ product.option }})</template
        >
        x {{ product.quantity }}
      </div>
      <div class=" warning--text" v-if="product.cart_remark">
        {{ $t("Remark") }}: {{ product.cart_remark }}
      </div>

      <p class="price">
        <template v-if="product.bundleprice != product.price * product.quantity">
          <span class="discount" style="margin-right:5px"
            >{{ currencySign }}{{ (product.price * product.quantity) | decimalFormat }}</span
          >
          {{ currencySign }}{{ product.bundleprice | decimalFormat }}
        </template>
        <template v-else
          >{{ currencySign }}{{ (product.price * product.quantity) | decimalFormat }}</template
        >
      </p>

      <div
        style="color: red; font-size: 12px; text-align: right"
        v-if="product.optionDetail && parseInt(product.optionDetail[2]) == 0"
      >
        {{ $t("Sold Out") }}
      </div>
      <div
        style="color: red; font-size: 12px; text-align: right"
        v-else-if="parseInt(product.optionDetail && product.optionDetail[2]) < product.quantity"
      >
        <template v-if="product.optionDetail && product.optionDetail[2] == 1">{{
          $t("Only {item} item left", { item: product.optionDetail[2] })
        }}</template>
        <template v-else>{{
          $t("Only {item} items left", { item: product.optionDetail[2] })
        }}</template>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["product"],
  computed: {
    ...mapGetters({
      isWholesale: "getWholesaleStatus",
      wholesale: "getWholesale",
      loadingPageProfile: "getLoadingPageProfile",
      pageProfile: "getPageProfile",
    }),
    currencySign: function() {
      if (this.pageProfile && this.pageProfile.pageid == "402026927063253") {
        return "$";
      } else if (this.pageProfile.pageid == "751241271893504") {
        return "K";
      } else {
        return "฿";
      }
    },
  },
};
</script>

<style scoped></style>
